/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { createTheme } from '@mantine/core'

export const theme = createTheme({
  colors: {
    primary: [
      '#bccaab',
      '#a6b88f',
      '#8fa773',
      '#799557',
      '#63833b',
      '#4c721f',
      '#366003',
      '#305503',
      '#2a4b02',
      '#244002'
    ]
  },
  defaultGradient: {
    from: 'orange',
    to: 'red',
    deg: 45
  },
  defaultRadius: 'md',
  // fontFamily: 'ArimaMaduraiLight, Roboto, Arial, Sans-Serif',
  fontFamily: 'Roboto, Arial, Sans-Serif',
  primaryColor: 'primary',
  headings: {
    // fontFamily: 'BrownSugar, "Roboto Condensed", Arial, Sans-Serif'
    fontFamily: '"Roboto Condensed", Arial, Sans-Serif'
  },
  components: {
    Accordion: {
      defaultProps: {
        chevronPosition: 'left'
      }
    },
    ActionIcon: {
      defaultProps: {
        variant: 'light'
      }
    },
    Button: {
      defaultProps: {
        variant: 'light'
      }
    },
    Card: {
      defaultProps: {
        padding: 'md'
      }
    },
    Container: {
      defaultProps: {
        px: 0
      }
    },
    Menu: {
      defaultProps: {
        shadow: 'sm',
        withArrow: true
      }
    },
    Modal: {
      defaultProps: {
        closeOnClickOutside: false,
        shadow: 'md'
      }
    },
    Overlay: {
      defaultProps: {
        bg: 'rgba(200,200,200,0.7)'
      }
    },
    Popover: {
      defaultProps: {
        shadow: 'sm',
        withArrow: true
      }
    }
  }
})
